// extracted by mini-css-extract-plugin
module.exports = {"addendum":"FoodFacilitiesList_addendum__34KCN bodySBold"};